<template>
  <!-- /* ------------------ 加入一层div防止element-menu 在菜单收起时hover报错问题 ----------------- */ -->
  <div :class="isCollapse && 'wrapper-submenu'">
    <el-submenu :index="item.path" :hide-timeout="0" :show-timeout="100">
      <template slot="title">
        <i class="el-icon-setting"></i>
        <span>{{ languages[item.path] && languages[item.path][lang] }}</span>
      </template>
      <template>
        <template v-for="(it, index) in item.children">
          <el-menu-item :index="it.path" :key="index" v-if="it.meta && !it.meta.isHide">
            <span slot="title">
              {{ languages[it.path] && languages[it.path][lang] }}
            </span>
          </el-menu-item>
          <!-- @FIXME - 取消递归渲染菜单树 -->
          <!-- <TreeMenu1
        v-if="it.childrenMenus && it.childrenMenus.length"
        :key="index + 's'"
        :item="it"
        :langs="langs"
      /> -->
        </template>
      </template>
    </el-submenu>
  </div>
</template>

<script>
export default {
  name: 'TreeMenu1',
  props: ['item', 'lang', 'languages', 'isCollapse'],
  computed: {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.wrapper-submenu {
 .el-submenu > .el-submenu__title span {
    height: 0;
    width: 0;
    overflow: hidden;
    visibility: hidden;
    display: inline-block;
  }
   .el-submenu > .el-submenu__title .el-submenu__icon-arrow {
    display: none;
  }
}

/deep/.el-submenu .el-menu {
  background-color: rgb(88, 87, 87);
  color: #fff;
}

/deep/.el-submenu .el-menu-item {
  background-color: rgb(88, 87, 87);
  color: #fff;
}

.el-menu-item:focus,
.el-menu-item:hover {
  background-color: gray !important;
}

/deep/.el-menu-item.is-active {
  background-color: gray !important;
  color: #fff;
}

</style>



// WEBPACK FOOTER //
// src/components/home/home-tree-memu.vue